import { useState } from 'react';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import Goals from './components/Goals';
import Package from './components/Package';
import Recipients from './components/Recipients';
import Donation from './components/Donation';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [showDonationForm, setShowDonationForm] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 via-white to-amber-50">
      <Hero onDonateClick={() => setShowDonationForm(true)} />
      <Introduction />
      <Goals />
      <Package />
      <Recipients />
      <Donation showForm={showDonationForm} onClose={() => setShowDonationForm(false)} />
      <Contact />
      <Footer />
    </div>
  );
}
